import PropTypes from 'prop-types';

export default PropTypes.object;


//////////////////
// WEBPACK FOOTER
// ../~/react-leaflet/es/propTypes/layer.js
// module id = 81
// module chunks = 0